import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'

import { SelectInput } from '@/modules/base/components/inputs'
import TaxCategoryDrawer from '@/modules/base/components/tax-categories/tax-categories-drawer'
import { openDrawer, closeDrawer, allAccountTypes, getChartsOfAccounts } from '@/redux/ducks/taxCategories/main'

const drawerSelectOption = { label: lang.openTaxAccountsDrawerLabel, value: 'openDrawer' }

const useStyles = makeStyles(theme => ({
  select: {
    width: '100%',
  },
  customTaxCategoryOption: {
    color: theme.primary,
    fontWeight: 500,
  },
}))

const TaxCategorySelectInput = (props) => {
  const { onChange, readOnly, value, name, accountType = allAccountTypes, label, dataQsId } = props
  const menuPlacement = 'bottom'

  const classes = useStyles()

  const dispatch = useDispatch()
  const [taxCategories, setTaxCategories] = useState([drawerSelectOption])
  const { favoriteCategories, rawCategories } = useSelector(state => state.taxCategories.main)

  useEffect(() => {
    dispatch(getChartsOfAccounts({ accountType }))
  }, [])

  useEffect(() => {
    const mappedFavoriteCategories = mapCategoriesToOptions(favoriteCategories)

    const categories = [
      ...mappedFavoriteCategories,
    ]

    // add selected category as option if it isn't in favorites
    if (value) {
      const existingCategory = mappedFavoriteCategories.find(category => category.id === value)
      if (!existingCategory) {
        const category = rawCategories.find(category => category.id === value)

        if (category) {
          const newCategory = {
            value,
            label: `${category.accountDescriptionCustom} (${category.accountNo})`,
          }
          categories.unshift(newCategory)
        }
      }
    }

    setTaxCategories([drawerSelectOption, ...categories])

  }, [favoriteCategories, value])

  const getCategorySelectOptions = (classes, menuPlacement) => ({
    placeholder: lang.generics.defaultCategory,
    isClearable: true,
    backspaceRemoves: true,
    menuPlacement,
    formatOptionLabel: (option) => {
      const { value, label } = option
      const customClass = value === 'openDrawer' ? classes.customTaxCategoryOption : ''
      return (
        <span className={`${classes.selectOption} ${customClass}`}>{label}</span>
      )
    },
  })

  const mapCategoriesToOptions = categories =>
    categories.map(category => ({
      label: `${category.accountDescriptionCustom} (${category.accountNo})`,
      value: category.id,
      ...category,
    }))

  const handleChange = (option) => {
    if (option && option.value === 'openDrawer') return dispatch(openDrawer())
    else dispatch(closeDrawer())

    onChange(option?.id)
  }

  return (
    <>
      <SelectInput
        label={label}
        containerClass={classes.select}
        name={name}
        notAsync
        allowCreate={false}
        customSelectOptions={getCategorySelectOptions(classes, menuPlacement)}
        value={value}
        options={taxCategories}
        handleChange={handleChange}
        disabled={readOnly}
        dataQsId={dataQsId}
      />
      <TaxCategoryDrawer onSubmit={handleChange} accountType={accountType} />
    </>
  )
}

TaxCategorySelectInput.propTypes = {
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  accountType: PropTypes.string,
  label: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

export default TaxCategorySelectInput
